import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOutsideClick]'
})

export class OutsideClickDirective {
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();
  }
}
